import WarningIcon from '@mui/icons-material/Warning';
import { ReportSectionStyled } from '@/reports/shared/ReportSection/ReportSection';
import { styled, Stack, Text, Card, Box } from '@/theme/index';
import { generateSearchVolumeText } from '@/utils/phone';

const Warning = styled(WarningIcon)(
  ({ theme }) => `
    color: ${theme.palette.error.main};
    height: 60px;
    width: 70px;
`
);

type Props = {
  searchCount: number;
};

export function SearchVolume({ searchCount }: Props) {
  const shouldShowSearchCount = searchCount > 0;
  const searchVolume = generateSearchVolumeText(searchCount);
  const searchCountCommaFormatted = searchCount.toLocaleString();
  const searchesText = searchCount === 1 ? 'search' : 'searches';

  return (
    <ReportSectionStyled id="search-volume-section">
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2.5}
      >
        <Warning />
        <Box textAlign="center">
          <Text variant="h1">Search volume: {searchVolume}</Text>
          <Text>
            Greater search rate correlates to increased likelihood of a call
            being spam
          </Text>
        </Box>
        {shouldShowSearchCount && (
          <Card variant="outlined" sx={{ width: '100%' }}>
            <Stack alignItems="center" justifyContent="center">
              <Text>This number has had </Text>
              <Text fontSize="30px">
                {searchCountCommaFormatted} {searchesText}
              </Text>
            </Stack>
          </Card>
        )}
      </Stack>
    </ReportSectionStyled>
  );
}
